import { ScrollTrigger } from 'gsap/ScrollTrigger'


$(window).on('load', function (e){

  ScrollTrigger.create({
    trigger: '.gsap-load-images',
    start: 'top bottom',
    end: 'bottom top',
    onEnter: function () {
      $('[gsap-lazy-style]').each(function (){
        $(this).attr('style', $(this).attr('gsap-lazy-style'))
      })
      $('[gsap-lazy-src]').each(function (){
        $(this).attr('src', $(this).attr('gsap-lazy-src'))
      })
    },
    once: true,
    //markers: true
  });

})


function gsapClickLazySet()
{
  $('[gsap-click-lazy-src]').each(function (e){
    $(this).attr('src', $(this).attr('gsap-click-lazy-src'))
  })
}

export { gsapClickLazySet }
